import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n/config'
import '@roo/roo/theme/default/index.css'
import './styles/global.css'
import initI18n from './common/utils/i18n'

initI18n(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
)


